/**
 * Shared constants for keyboard-shortcut wiring. Lives in its own module to break the
 * runtime cycle that would form if these were exported from `useKeyboardShortcuts.ts`
 * (the hook imports `usePageShortcutsRegistration` from this directory's barrel, which
 * also re-exports `Overlay` — and `Overlay` imports `DOCS_URL`).
 */

/** Custom event dispatched by the keyboard hook when `N` is pressed. `NotificationsDropdown`
 * listens for this to open the bell menu without a cross-module ref. */
export const OPEN_NOTIFICATIONS_EVENT = 'synop:open-notifications'

/** Docs site URL — used by `Shift+D` global shortcut and the help overlay's docs link. */
export const DOCS_URL = 'https://synop.readme.io/'
